module.exports = __webpack_public_path__ + "static/media/artist_ehy-x_w.838c59ea.png";